export const defaultLogoUrl = "/form/images/smartsuite-logo.svg";
